import moment from 'moment';
import { createContext } from 'react';
import {
  AI_CONVERSATION_MESSAGES_LIMIT,
  MAX_TIME_WAITING_CONVERSATION,
} from 'utils/constants';
import {
  AIConversation,
  AIConversationMessage,
  AIConversationSearchType,
  AIConversationStatus,
  MessageRole,
} from 'v2/models';
export type AISearchType = 'Documents' | 'Data Concierge';
export type AISearchTypeDisplay = 'Data Concierge' | 'Document';

export const AISearchTypes: Record<string, AISearchType> = {
  document: 'Documents',
  drm: 'Data Concierge',
};

export const AISearchTypesDisplay: Record<
  AIConversationSearchType,
  AISearchTypeDisplay
> = {
  document: 'Document',
  drm: 'Data Concierge',
};

export const AISearchRequiresFiles: Record<string, boolean> = {
  drm: false,
  document: true,
};

export interface CurrentStateWaitingConversationContextValue {
  waitingConversation: number | undefined;
}

export const CurrentStateWaitingConversationContext =
  createContext<CurrentStateWaitingConversationContextValue>({
    waitingConversation: undefined,
  });

export const isAiSearchRunning = (aiSearch?: AIConversation) => {
  const staticStates = [
    AIConversationStatus.COMPLETED,
    AIConversationStatus.CREATED,
    AIConversationStatus.FAILED,
  ];
  return aiSearch && !staticStates.includes(aiSearch.status);
};

export const sortByLastSubmission = (
  aiSearchA: AIConversation,
  aiSearchB: AIConversation
) => {
  const dateA = moment(aiSearchA.last_submission);
  const dateB = moment(aiSearchB.last_submission);
  if (dateA.isAfter(dateB)) return -1;
  else if (dateB.isAfter(dateA)) return 1;
  return 0;
};

export const getWaitingConversation = (
  conversations: AIConversation[]
): number | undefined => {
  const lastRunningConversation = conversations
    .filter(isAiSearchRunning)
    .sort(sortByLastSubmission)
    .shift();

  if (lastRunningConversation) {
    const waitingTime = moment().diff(
      lastRunningConversation.last_submission,
      'seconds'
    );
    if (waitingTime < MAX_TIME_WAITING_CONVERSATION)
      return lastRunningConversation.id;
  }
};

export const isAIMessageLimitReached = (messages: AIConversationMessage[]) => {
  const filteredMessages = messages.filter((message) =>
    MessageRole.USER.includes(message.role)
  );
  return filteredMessages.length >= AI_CONVERSATION_MESSAGES_LIMIT;
};
